import styled, { css } from 'styled-components';

interface ScFlyingElementProps {
  positionX: number | string;
  positionY: number | string;
  positionXMob: number | string;
  positionYMob: number | string;
  delay: number;
  maxWidthMobile: number;
  size?: number;
  sizeMob?: number;
}

export const ScFlyingElement = styled.img<ScFlyingElementProps>`
  position: absolute;
  top: ${({ positionY }) =>
    typeof positionY === 'string' ? positionY : `${positionY}%`};
  left: ${({ positionX }) =>
    typeof positionX === 'string' ? positionX : `${positionX}%`};
  transform: translate(-50%, -50%);
  aspect-ratio: 1 / 1;
  z-index: 0;
  ${({ size }) =>
    size &&
    css`
      width: ${size}px;
    `};

  animation: move infinite ${({ delay }) => delay}s ease-in-out;

  @media (max-width: ${({ maxWidthMobile }) => maxWidthMobile}px) {
    top: ${({ positionYMob }) =>
      typeof positionYMob === 'string' ? positionYMob : `${positionYMob}%`};
    left: ${({ positionXMob }) =>
      typeof positionXMob === 'string' ? positionXMob : `${positionXMob}%`};
    ${({ sizeMob }) =>
      sizeMob
        ? css`
            width: ${sizeMob}px;
          `
        : css`
            zoom: 0.6;
          `};
  }

  @keyframes move {
    0% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(15px);
    }

    100% {
      transform: translateY(0);
    }
  }
`;
